<template>
  <div class="login">
    <div class="login__container">
      <div class="login__brand">
        <img class="tingg-brand-logo" src="https://developer.tingg.africa/checkout/v2/web-assets/images/tingg-logo-white.svg" height="64" alt="Tingg"/>
      </div>

      <div class="login__card">
        <div v-show="showError" class="help-text tingg-error-help" style="display: none;">
          <span>Your credentials don't match our records</span>
        </div>

        <h3 class="login__card-title">Sign In</h3>

        <form v-on:submit.prevent="signIn" novalidate>
          <div :class="{'form-group': true, 'has-error': errors.has('email') }">
            <label class="mula-form-group__label control-label" for="email">Email</label>
            <input v-validate='{required: true, email: true}' class="mula-form-group__input form-control" id="email" name="email" type="email" autocomplete="email" v-model="email"/>
            <span v-show="errors.has('email')" class="help tingg-validation-error">Your email is required</span>
          </div>

          <div :class="{'form-group': true, 'has-error': errors.has('password') }">
            <label class="mula-form-group__label control-label" for="password">Password</label>
            <input v-validate='{required: true, min:5}' class="mula-form-group__input form-control" id="password" name="password" type="password" autocomplete="password" v-model="password"/>
            <span v-show="errors.has('password')" class="help tingg-validation-error">{{ errors.first('password') }}</span>
          </div>

          <div class="login__forgot-password">
            <a class="tingg-anchors" href="#" @click.prevent="goTo('recover/password')">Forgot password?</a>
          </div>

          <button class="mula-btn tingg-primary-button ladda-button" data-style="zoom-in" type="submit">Login</button>
        </form>
        <div class="login__optional-cta">
          <span>Don't have an account?</span>
          <a class="tingg-anchors" href="#" @click.prevent="goTo('/register/user')">Register</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { mapActions } from 'vuex'
  import Auth from '@/api/services/auth.js'

  const logInfo = !!(process.env.NODE_ENV !== 'production')

  export default {
    data () {
      return {
        email: '',
        password: '',
        showError: false
      }
    },
    methods: {
      ...mapActions('auth', ['login']),
      ...mapActions('services', ['saveServices']),
      ...mapActions('user', ['saveUserInformation', 'saveUserKeys']),
      signIn () {
        // Reset the page as we try authenticate the user.
        this.showError = false
        // Check that all the user is expected to
        // fill in is provided
        this.$validator.validateAll()
          .then(result => {
            logInfo && console.log('Did the login request pass validation?', result)

            if (result) {
              this.$btn.disable('.mula-btn')

              // Attempt to login the user.
              Auth.attemptSignIn({email: this.email, password: this.password})
                .then(response => {
                  logInfo && console.log('User was successfully authenticated', response)
                  // Persist the user's token
                  this.login(response.DATA.authorizationToken)

                  // Persist the user's information, services and keys
                  this.saveServices(_.pick(response.DATA, ['serviceDetails']))
                  this.saveUserKeys(_.pick(response.DATA, ['clientAccessKeys', 'oauthKeyDetails']))
                  this.saveUserInformation(_.omit(response.DATA, [
                    'authorizationToken',
                    'clientAccessKeys',
                    'oauthKeyDetails',
                    'serviceDetails'
                  ]))
                  this.$btn.enable('.mula-btn')
                  this.$router.push('/home')
                })
                .catch(response => {
                  logInfo && console.log('User was not authenticated', response)
                  // Stop the button loader
                  // l.stop()
                  // Show the error message
                  this.showError = true
                  this.$btn.enable('.mula-btn')
                })
            }
          })
          .catch(reason => {
            logInfo && console.log('The user credentials have failed validation', reason)
          })
      }
    },
    name: 'Login'
  }
</script>

<style lang="scss">
  @import "../styles/theme";

  .login {
    width: 100%;
    height: 100vh;
    align-items: start;

    display: flex;
    justify-content: center;
    background-image: linear-gradient(to bottom right, $tingg-primary-red, $tingg-purple);
  }

  .login__container {
    height: 75%;

    margin-top: 2.5rem;

    @include make-col-ready();

    @include media-breakpoint-down(xl) {
      @include make-col(4);
    }

    @include media-breakpoint-down(md) {
      @include make-col(8);
    }

    @include media-breakpoint-down(sm) {
      @include make-col(10);
    }

    @include media-breakpoint-down(xs) {
      @include make-col(12);
    }
  }

  .login__card {
    width: 100%;
    border-radius: 2px;
    padding: 1.5rem 3rem;
    background-color: $background-white;
  }

  .login__card-title {
    width: 100%;
    font-size: 25px;
    text-align: center;
    margin-bottom: 1.5rem;
  }

  .login__brand {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 2.5rem;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/Login.vue